import React, {useCallback} from 'react';

import {AddLinkModal} from './AddLinkModal';
import {useEntityPageContext, useEntityPageUpdaterContext} from './context';
import {EmptyState} from './EmptyState';
import {LinkCards} from './LinkCards';

type LinksSectionProps = {
  showEmptyState: boolean;
  setAddingLink: (addingLink: boolean) => void;
  addingLink: boolean;
  startAdding: () => void;
};

export const LinksSection: React.FC<LinksSectionProps> = React.memo(
  ({showEmptyState, setAddingLink, addingLink, startAdding}) => {
    const {links, readOnly} = useEntityPageContext();
    const {setLinks} = useEntityPageUpdaterContext();
    const stopAdding = useCallback(() => {
      setAddingLink(false);
    }, [setAddingLink]);

    return (
      <>
        {showEmptyState ? (
          <EmptyState
            iconName="link-alt"
            header={`Add links to your profile`}
            body={`Share a little bit about yourself`}
            buttonText={`Add a link`}
            onClickButton={startAdding}
          />
        ) : (
          <LinkCards items={links} setItems={setLinks} readOnly={readOnly} />
        )}
        {addingLink && <AddLinkModal onClose={stopAdding} />}
      </>
    );
  }
);
